// password-input-switcher.js
;(() => {
    const activeClass = 'password-input-switcher--active'
    document.querySelectorAll('.password-input-switcher').forEach(pis => {
        const trigger = pis.querySelector('.password-input-switcher__trigger')
        const input = pis.querySelector('.password-input-switcher__input')
        if (!trigger || !input) return

        trigger.addEventListener('click', () => {
            if (pis.classList.contains(activeClass)) {
                pis.classList.remove(activeClass)
                input.type = 'password'
            } else {
                pis.classList.add(activeClass)
                input.type = 'text'
            }
        })
    })
})();